module.exports = __webpack_public_path__ + "static/img/NO.59aa1e9b.png";